import { getPendingAttachmentString } from 'owa-attachment-block-on-send/lib/lazyIndex';
import { isStringNullOrWhiteSpace } from 'owa-localize';
import { hasPendingSaveAction } from 'owa-mail-compose-actions/lib/actions/trySaveMessage';
import { ComposeViewState } from 'owa-mail-compose-store';
import SmimeAdminSettingsType from 'owa-service/lib/contract/SmimeAdminSettingsType';
import { getUserConfiguration } from 'owa-session-store';
import { isSmimeAdminSettingEnabled } from 'owa-smime/lib/utils/smimeSettingsUtil';

/**
 * Disable S/MIME options toggling if
 * 1. From is visible.
 * 2. AlwaysShowFrom setting is enabled.
 * 3. There are any pending attachments.
 * 4. S/MIME admin settings are enabled.
 * 5. An encrypting CLP label is selected.
 */
const isSmimeOptionDisabled = (
    composeViewState: ComposeViewState,
    shouldEncryptMessageAsSmimeCheckbox: boolean
): boolean => {
    const userConfig = getUserConfiguration();
    const { clpViewState } = composeViewState;
    const { selectedCLPLabel } = clpViewState;
    const selectedCLPLabelHasEncryption = selectedCLPLabel
        ? selectedCLPLabel.isEncryptingLabel
        : false;

    let alwaysSign = false;
    let alwaysEncrypt = false;

    if (isSmimeAdminSettingEnabled()) {
        const smimeAdminSettings: SmimeAdminSettingsType = userConfig.SmimeAdminSettings;
        alwaysSign = smimeAdminSettings.AlwaysSign;
        alwaysEncrypt = smimeAdminSettings.AlwaysEncrypt;
    }

    return (
        composeViewState.fromViewState.isFromShown ||
        userConfig.UserOptions.AlwaysShowFrom ||
        !isStringNullOrWhiteSpace(
            getPendingAttachmentString(
                composeViewState.attachmentWell,
                false /* hasWaitingAttachment */
            )
        ) ||
        hasPendingSaveAction(composeViewState) ||
        (shouldEncryptMessageAsSmimeCheckbox ? alwaysEncrypt : alwaysSign) ||
        selectedCLPLabelHasEncryption
    );
};

export default isSmimeOptionDisabled;
